import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'subaccounts.list.pagination', {});
export const getFilters = (state) => get(state, 'subaccounts.list.filters', {});

export const getSubaccountsIds = (state) => get(state, 'subaccounts.list.result.subaccounts', []);
export const getSubaccounts = (state) => get(state, 'subaccounts.list.entities.subaccounts', {});

export const getIsLoading = (state) => get(state, 'subaccounts.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'subaccounts.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'subaccounts.form.isFetching', false);
export const getIsFetchingConfig = (state) =>
  get(state, 'subaccounts.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'subaccounts.form.isSaving', false);
export const getEditing = (state) => get(state, 'subaccounts.form.editing', false);

export const getVisibleSubaccounts = createSelector(
  [getSubaccountsIds, getSubaccounts],
  (ids, subaccounts) => ids.map((id) => subaccounts[id]).filter((subaccount) => !subaccount.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/subaccounts/selectors/subaccounts_selectors.js